<template>
  <div class="auditlist">
    <el-form
      :inline="true"
      :model="formInline"
      class="demo-form-inline">
      <el-dropdown @command="editdropdownitem">
        <el-button type="primary">
          {{ dropdownitem[1] }}
          <i class="el-icon-arrow-down el-icon--right"/>
        </el-button>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item
            v-for="(item,index) in dropdownlist"
            :command="index"
            :key="item+index">{{ item[1] }}</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </el-form>
    <el-table
      v-loading="loading"
      :data="auditlist.LsList"
      border
      style="width: 100%">
      <el-table-column
        :width="100"
        label="姓名"
        align="center"
        prop="UserName"/>
      <el-table-column
        :formatter="ValidStatusFilter"
        label="审核状态"
        width="100"
        prop="StatusNo"
        align="center"/>
      <el-table-column
        label="提现申请时间"
        align="center"
        prop="AddTime"/>
      <el-table-column
        label="提现金额"
        align="center"
        prop="Rmb"/>
      <el-table-column
        label="提现方式"
        align="center"
        prop="AccountType"/>
      <el-table-column
        :formatter="ValidStatusFilter"
        label="提现状态"
        align="center"
        prop="RetCoinStatus"/>
      <el-table-column
        label="消息提示"
        align="center"
        prop="RetCoinMemo"/>
      <el-table-column
        label="错误代码"
        align="center"
        prop="RetCoinCode"/>
      <el-table-column
        label="提现完成时间"
        align="center"
        prop="PaymentTime"/>
      <el-table-column
        label="提现更新时间"
        align="center"
        prop="UpdateTime"/>
      <el-table-column
        label="提现单号"
        align="center"
        prop="PaymentNo"/>
      <el-table-column
        align="center"
        label="操作"
        width="200"
      >
        <template slot-scope="scope">
          <el-button
            v-if="scope.row.RetCoinStatus=='SUCCESS'&&calcPermission(permition, 1)"
            size="mini"
            type="text">已提现成功</el-button>
          <div v-if="scope.row.RetCoinStatus!='SUCCESS'&&calcPermission(permition, 1)">
            <el-button
              v-if="scope.row.StatusNo=='AT'&&calcPermission(permition, 1)"
              size="mini"
              @click="handleEdit(scope.$index, scope.row)">通过</el-button>
            <el-button
              v-if="scope.row.StatusNo=='AS'&&scope.row.RetCoinStatus=='ERROR'&&calcPermission(permition, 1)"
              size="mini"
              @click="handleEdit(scope.$index, scope.row)">重试</el-button>
            <el-button
              v-if="scope.row.StatusNo!='AS'||scope.row.StatusNo!='AF'"
              size="mini"
              type="danger"
              @click="handleDelete(scope.$index, scope.row)&&calcPermission(permition, 2)">不通过</el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-container">
      <el-pagination
        v-show="checkedDeviceBoxs.TotalRows>0"
        :current-page="listQuery.pageIndex"
        :page-sizes="[10,20,50,100]"
        :page-size="listQuery.pageSize"
        :total="checkedDeviceBoxs.TotalRows"
        background
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange" />
    </div>
  </div>
</template>
<script>
import { qryRoleInfo } from '@/api/baseModule'
import { qryReturnCoin, verifyPass, verifyNoPass } from '@/api/account'
export default {
  name: 'Cashaudit',
  data() {
    return {
      auditlist: {
        LsList: []
      },
      formInline: {
        user: '',
        region: ''
      },
      dropdownlist: [['AT', '待审核'], ['AS', '审核成功']],
      dropdownitem: ['', '请选择查询条件'],
      loading: true,
      dialogVisible: false,
      auditinfo: {
        UserInfo: {
          UserName: null,
          WorkNumPic: ''
        }
      },
      permition: 0,
      checkedDeviceBoxs: { TotalRows: 0 },
      listQuery: {
        pageIndex: 1,
        pageSize: 10,
        identity: undefined,
        type: undefined,
        address: undefined,
        userId: this.$store.getters.roles.UserId
      }
    }
  },
  created() {
    if (this.$store.state.roleInfo) {
      this.$store.state.roleInfo.LsList[0].RolePrograms.forEach(item => {
        if (this.$route.path === item.ProgramInfo.PgUrl) {
          this.permition = item.Permition
          qryReturnCoin({ pageIndex: 1, pageSize: 10 }).then(Response => {
            this.auditlist = Response
            this.checkedDeviceBoxs.TotalRows = Response.TotalRows
            this.loading = false
          })
        }
      })
    } else {
      qryRoleInfo({
        rId: this.$store.getters.roles.RoleId
      }).then(response => {
        this.$store.state.roleInfo = response
        response.LsList[0].RolePrograms.forEach(item => {
          if (this.$route.path === item.ProgramInfo.PgUrl) {
            this.permition = item.Permition
            qryReturnCoin({ pageIndex: 1, pageSize: 10 }).then(Response => {
              this.auditlist = Response
              this.checkedDeviceBoxs.TotalRows = Response.TotalRows
              this.loading = false
            })
          }
        })
      })
    }
  },
  methods: {
    getAuditlist({ pageIndex, pageSize }) {
      qryReturnCoin({
        pageIndex: this.listQuery.pageIndex,
        pageSize: this.listQuery.pageSize
      }).then(response => {
        this.auditlist = response
        this.checkedDeviceBoxs.TotalRows = response.TotalRows
        this.loading = false
      })
    },
    handleEdit(index, row) {
      this.loading = true
      verifyPass({ coinId: row.CoinId }).then(response => {
        this.$message({
          type: 'success',
          message: '审核成功'
        })
        this.getAuditlist({
          pageIndex: this.listQuery.pageIndex,
          pageSize: this.listQuery.pageSize
        })
        this.loading = false
      })
    },
    handleDelete(index, row) {
      this.$prompt('请输入不通过信息', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      })
        .then(({ value }) => {
          this.loading = true
          verifyNoPass({ coinId: row.CoinId, content: value }).then(response => {
            this.$message({
              type: 'success',
              message: '审核不通过成功'
            })
            this.getAuditlist({
              pageIndex: this.listQuery.pageIndex,
              pageSize: this.listQuery.pageSize
            })
            this.loading = false
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '取消操作'
          })
        })
    },
    handleSee(index, row) {
      this.auditinfo = row
      this.dialogVisible = true
    },
    ValidStatusFilter(row, column, cellValue, index) {
      if (cellValue === 'AS') {
        return '审核通过'
      }
      if (cellValue === 'AF') {
        return '审核失败'
      }
      if (cellValue === 'AT') {
        return '审核中'
      }
      if (cellValue === 'SUCCESS') {
        return '提现成功'
      }
      if (cellValue === 'ERROR') {
        return '提现失败'
      }
    },
    handleClose(done) {
      this.$confirm('确认关闭？')
        .then(_ => {
          done()
        })
        .catch(_ => { })
    },
    handleSizeChange(val) {
      this.listQuery.pageSize = val
      this.getAuditlist({
        pageIndex: this.listQuery.pageIndex,
        pageSize: this.listQuery.pageSize
      })
    },
    handleCurrentChange(val) {
      this.listQuery.pageIndex = val
      this.getAuditlist({
        pageIndex: this.listQuery.pageIndex,
        pageSize: this.listQuery.pageSize
      })
    }
  },
  editdropdownitem(command) {
    this.dropdownitem = this.dropdownlist[command]
    qryReturnCoin({
      status: this.dropdownitem[0],
      pageIndex: this.listQuery.pageIndex,
      pageSize: this.listQuery.pageSize
    }).then(response => {
      this.auditlist = response
      this.checkedDeviceBoxs.TotalRows = response.TotalRows
      this.loading = false
    })
  }

}
</script>
<style lang="less" scoped>

</style>
